import { Component, ElementRef, OnInit, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DummyTeacherSM } from 'src/app/service-models/v1/dummy-teacher-s-m';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { TeacherService } from 'src/app/services/teacher.service';
import { DummyTeacherViewModel } from 'src/app/view-models/dummy-teacher.viewmodel';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-dummy-teacher',
  templateUrl: './dummy-teacher.component.html',
  styleUrls: ['./dummy-teacher.component.scss']
})
export class DummyTeacherComponent extends BaseComponent<DummyTeacherViewModel> implements OnInit {

  /**
   * comments here and summary of the function
   *
   */
  constructor(private modalService: NgbModal, private teacherService: TeacherService,
    commonService: CommonService, logService: LogHandlerService) {
    super(commonService, logService);
    this.viewModel = new DummyTeacherViewModel();
  }

  async ngOnInit() {
    await this.loadPageData()
  }

  override async loadPageData() {
    try {
      await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.teacherService.getAllTeachers();
      if (resp.isError) {
        await this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
      }
      else {
        this.viewModel.teachers = resp.successData;
      }
    } catch (error) {
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }
  async getTeacherById(teacherId: number) {
    try {
      await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.teacherService.getTeacherById(teacherId);
      if (resp.isError) {
        await this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
        ;
      }
      else {
        this.viewModel.singleTeacher = resp.successData;
      }
    } catch (error) {
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }

  async click_OpenAddEditModal(content: TemplateRef<any>, teacherId: number) {
    this.viewModel.AddEditModalTitle = teacherId > 0 ? 'Add Teacher' : 'Update Teacher';
    this.viewModel.singleTeacher = new DummyTeacherSM();
    if (teacherId > 0)
      await this.getTeacherById(teacherId);
    await this.modalService.open(content).result.then(
      (result: any) => {
      },
      (reason: any) => {
      },
    );
  }


  async deleteTeacher(id: number) {
    try {
      let resp = await this.teacherService.deleteTeacher(id);
    } catch (error) {
      //show error message user friendly 
      throw error;
    }

  }
}
